import { graphql } from "relay-runtime"

export const deConfirmBetterDocRejection = graphql`
  mutation deConfirmBetterDocRejectionMutation($input: De_confirmBetterDocRejectionInput!) {
    confirmBetterDocRejection: de_confirmBetterDocRejection(input: $input) {
      ProgressNoteMutationOutput: de_ProgressNoteMutationOutput {
        progressNote {
          id
          updatedAt
          betterDoc {
            rejectionReason
          }
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
